webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return storage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });


var config = {
  apiKey: 'AIzaSyAmcCcvuccB8p_LNXmhwtl53uA9dp0x4-c',
  authDomain: 'chilloutmusic-ba889.firebaseapp.com',
  databaseURL: 'https://chilloutmusic-ba889.firebaseio.com',
  storageBucket: 'chilloutmusic-ba889.appspot.com',
  messagingSenderId: '812370035445'
};

__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

/* unused harmony default export */ var _unused_webpack_default_export = {
  database: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database()
};

var db = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database();
var storage = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage();
var auth = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth();

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_braincomb_code_chilloutmusic_website_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_braincomb_code_chilloutmusic_website_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_braincomb_code_chilloutmusic_website_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_firebase__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuefire__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuefire__);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* unused harmony reexport firebase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });









__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuefire___default.a);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__home_braincomb_code_chilloutmusic_website_node_modules_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_3__components_App___default.a));



/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return relativeDate; });
// Taken from: https://cdn.rawgit.com/n-johnson/relative-date/a3819807/lib/relative-date.js
var relativeDate = function (undefined) {

  var SECOND = 1000,
      MINUTE = 60 * SECOND,
      HOUR = 60 * MINUTE,
      DAY = 24 * HOUR,
      WEEK = 7 * DAY,
      YEAR = DAY * 365,
      MONTH = YEAR / 12;

  var formats = [[0.7 * MINUTE, 'just now'], [1.5 * MINUTE, 'a minute ago'], [60 * MINUTE, 'minutes ago', MINUTE], [1.5 * HOUR, 'an hour ago'], [DAY, 'hours ago', HOUR], [2 * DAY, 'yesterday'], [7 * DAY, 'days ago', DAY], [1.5 * WEEK, 'a week ago'], [MONTH, 'weeks ago', WEEK], [1.5 * MONTH, 'a month ago'], [YEAR, 'months ago', MONTH], [1.5 * YEAR, 'a year ago'], [Number.MAX_VALUE, 'years ago', YEAR]];

  function relativeDate(input, reference) {
    !reference && (reference = new Date().getTime());
    reference instanceof Date && (reference = reference.getTime());
    input instanceof Date && (input = input.getTime());

    var delta = reference - input,
        format,
        i,
        len;

    for (i = -1, len = formats.length; ++i < len;) {
      format = formats[i];
      if (delta < format[0]) {
        return format[2] == undefined ? format[1] : Math.round(delta / format[2]) + ' ' + format[1];
      }
    };
  }

  return relativeDate;
}();



/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Events__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Rdj__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Rdj___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Rdj__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Rules__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Rules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Rules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Bot__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Bot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Bot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Triggers__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Triggers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_Triggers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Admin__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Unknown__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Unknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_Unknown__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/rdj',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Rdj___default.a
  }, {
    path: '/rules',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Rules___default.a
  }, {
    name: 'bot',
    path: '/bot/:type?',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Bot___default.a
  }, {
    path: '/triggers',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Triggers___default.a
  }, {
    path: '/events',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Events___default.a
  }, {
    path: '/admin',
    component: __WEBPACK_IMPORTED_MODULE_8__views_Admin___default.a
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Unknown___default.a
  }, { path: '/bot-commands', redirect: '/bot' }, { path: '/games', redirect: '/bot/games' }, { path: '/leaderboard', redirect: '/bot/leaderboard' }, { path: '/residentdjs', redirect: '/rdj' }]
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(179);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  triggers: []
};

var mutations = {
  saveTriggers: function saveTriggers(state, data) {
    state.triggers = data;
  }
};

var actions = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',

  data: function data() {
    return {
      isHamburgerActive: false
    };
  },


  methods: {
    toggleHamburger: function toggleHamburger() {
      this.isHamburgerActive = !this.isHamburgerActive;
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Admin',
  data: function data() {
    return {
      file: {},
      email: '',
      password: '',
      authenticated: false,
      disabled: true,
      error: '',
      message: '',
      rdj: {
        name: '',
        type: 'producer',
        youtube: '',
        soundcloud: '',
        bandcamp: '',
        twitter: '',
        facebook: '',
        location: '',
        imageUrl: ''
      }
    };
  },

  computed: {
    user: {
      cache: false,
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* auth */].currentUser;
      }
    }
  },
  methods: {
    fileBtn: function fileBtn(file, e) {
      e.preventDefault();
      var uploader = document.getElementById('uploader');
      this.file = e.target.files[0];
      this.disabled = false;
    },
    addRdj: function addRdj() {
      var vm = this;
      var rdjRef = __WEBPACK_IMPORTED_MODULE_0__service_firebase__["b" /* db */].ref('rdjs');

      rdjRef.orderByChild("name").equalTo(vm.rdj.name).once("value", function (snapshot) {
        var data = snapshot.val();
        if (data) {
          // TODO: exists, update data
          vm.error = vm.rdj.name + " already exists.";
        } else {
          // does not exist, add data
          vm.error = '';
          var storageRef = __WEBPACK_IMPORTED_MODULE_0__service_firebase__["c" /* storage */].ref('rdjs/' + vm.file.name);

          var task = storageRef.put(vm.file);
          task.on('state_changed', function (snapshot) {
            var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            console.log('Upload is ' + progress + '% done');
            switch (snapshot.state) {
              case 'paused':
                console.log('Upload is paused');
                break;
              case 'running':
                console.log('Upload is running');
                break;
            }
          }, function (error) {
            console.log(error);
          }, function () {
            vm.rdj.imageUrl = task.snapshot.downloadURL;
            rdjRef.push(vm.rdj);
            vm.message = vm.rdj.name + " added successfully.";

            // Update metadata properties
            var newMetadata = {
              cacheControl: 'public,max-age=15768000',
              contentType: 'image/jpeg'
            };
            storageRef.updateMetadata(newMetadata).then(function (metadata) {
              console.log("Metadata added successfully.");
            }).catch(function (error) {
              vm.error = 'Metadata update failed!';
            });
          });
        }
      });
    },
    signIn: function signIn() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* auth */].signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        vm.$forceUpdate();
      }).catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === 'auth/wrong-password' || errorCode === 'auth/user-not-found') {
          vm.error = 'Invalid credentials.';
        } else {
          vm.error = errorMessage;
        }
        console.log(error);
      });
    },
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* auth */].signOut();
      this.$forceUpdate();
    }
  },
  beforeCreate: function beforeCreate() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0__service_firebase__["a" /* auth */].onAuthStateChanged(function (user) {
      if (user) {
        vm.authenticated = true;
      } else {
        vm.authenticated = false;
      }
    });
  }
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Bot',

  data: function data() {
    return {
      tabUserActive: true,
      tabModActive: false,
      tabGamesActive: false,
      tabLeaderboardActive: false,
      userCommands: [],
      modCommands: [],
      chillcoinCommands: [],
      loveCommands: [],
      leaderboard: [],
      errors: []
    };
  },


  methods: {
    toggle: function toggle(tab) {
      if (tab === 'user') {
        this.tabUserActive = true;
        this.tabModActive = false;
        this.tabGamesActive = false;
        this.tabLeaderboardActive = false;
        this.$router.replace({ name: 'bot', params: { type: 'user' } });
      }
      if (tab === 'mod') {
        this.tabUserActive = false;
        this.tabModActive = true;
        this.tabGamesActive = false;
        this.tabLeaderboardActive = false;
        this.$router.replace({ name: 'bot', params: { type: 'mod' } });
      }
      if (tab === 'games') {
        this.tabUserActive = false;
        this.tabModActive = false;
        this.tabGamesActive = true;
        this.tabLeaderboardActive = false;
        this.$router.replace({ name: 'bot', params: { type: 'games' } });
      }
      if (tab === 'leaderboard') {
        this.tabUserActive = false;
        this.tabModActive = false;
        this.tabGamesActive = false;
        this.tabLeaderboardActive = true;
        this.$router.replace({ name: 'bot', params: { type: 'leaderboard' } });
      }
    }
  },

  created: function created() {
    var _this = this;

    if (this.$route.params.type == 'leaderboard') {
      this.toggle('leaderboard');
    } else if (this.$route.params.type == 'games') {
      this.toggle('games');
    } else if (this.$route.params.type == 'mod') {
      this.toggle('mod');
    } else if (this.$route.params.type == 'user') {
      this.toggle('user');
    } else {
      this.$router.replace({ name: 'bot', params: { type: 'user' } });
    }
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/userCommands.json').then(function (response) {
      _this.userCommands = response.data;
    }).catch(function (e) {
      _this.errors.push(e);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/modCommands.json').then(function (response) {
      _this.modCommands = response.data;
    }).catch(function (e) {
      _this.errors.push(e);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/chillcoinCommands.json').then(function (response) {
      _this.chillcoinCommands = response.data;
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.woots.io/the-chillout-room/leaderboard').then(function (response) {
      _this.leaderboard = response.data;
    }).catch(function (e) {
      _this.errors.push(e);
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/loveCommands.json').then(function (response) {
      _this.loveCommands = response.data;
    }).catch(function (e) {
      _this.errors.push(e);
    });
  }
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Events'
};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Home',
  data: function data() {
    return {
      isMobile: false
    };
  },
  created: function created() {
    if (document.body.clientWidth <= 768) {
      this.isMobile = true;
    }

    // axios.get(`https://braincomb.com/cm/playing.json`)
    // .then(response => {
    //   this.playing = response.data.current
    //   this.played = response.data.played
    // })
    // .catch(e => {
    //   this.errors.push(e)
    // })
  }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_firebase__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Rdj',

  data: function data() {
    return {
      showType: 'all'
    };
  },


  firebase: {
    rdjs: __WEBPACK_IMPORTED_MODULE_0__service_firebase__["b" /* db */].ref('rdjs')
  },

  beforeCreate: function beforeCreate() {}
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Rules'
};

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters_relativeDate__ = __webpack_require__(69);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Triggers',

  data: function data() {
    return {
      sortKey: 'dateAdded',
      reverse: true,
      searchString: '',
      errors: [],
      isLoading: true,
      isMobile: false,
      itemsToShow: 200,
      itemsFound: 0
    };
  },


  computed: {
    triggers: function triggers() {
      return this.$store.state.triggers;
    },

    triggersTotal: function triggersTotal() {
      return this.triggers.length;
    }
  },

  methods: {
    debounceSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (e) {
      this.searchString = e.target.value;
    }, 250),
    sortBy: function sortBy(sortKey) {
      this.reverse = !this.reverse;
      this.sortKey = sortKey;
      this.$store.commit('saveTriggers', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.triggers, sortKey === 'creator.username' ? [function (user) {
        return user.creator.username.toLowerCase();
      }] : sortKey, this.reverse ? 'desc' : 'asc'));
    },
    filterBy: function filterBy(list, value) {
      return list.filter(function (item) {
        var combined = [item.keyword.toLowerCase(), item.content.toLowerCase(), item.creator.username.toLowerCase()].join(' ');
        return combined.indexOf(value.toLowerCase()) > -1;
      });
    },
    limitBy: function limitBy(list) {
      this.itemsFound = list.length;
      return list.slice(0, this.itemsToShow);
    },
    showMore: function showMore() {
      this.itemsToShow += 200;
    },
    keyMonitor: function keyMonitor() {
      var _this = this;

      this.isLoading = true;
      setTimeout(function () {
        return _this.isLoading = false;
      }, 500);
    },
    highlight: function highlight(value) {
      if (this.searchString) {
        var query = new RegExp(this.searchString + '(?![^<]*>|[^<>]*<\/)', "ig");
        return value.toString().replace(query, function (matchedText, a, b) {
          return '<span class=\'search-highlight\'>' + matchedText + '</span>';
        });
      } else {
        return value;
      }
    },
    linkify: function linkify(value) {
      var query = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?/gi;
      return value.toString().replace(query, function (matchedText, a, b) {
        return '<a target="blank" href="' + matchedText + '">' + matchedText + '</a>';
      });
    },
    emojify: function (_emojify) {
      function emojify(_x) {
        return _emojify.apply(this, arguments);
      }

      emojify.toString = function () {
        return _emojify.toString();
      };

      return emojify;
    }(function (value) {
      return emojify.replace(value);
    }),
    relativeDate: function relativeDate(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__filters_relativeDate__["a" /* relativeDate */])(new Date(value));
    }
  },

  created: function created() {
    var _this2 = this;

    if (document.body.clientWidth <= 920) {
      this.isMobile = true;
    }

    emojify.run();
    emojify.setConfig({ img_dir: 'https://cdnjs.cloudflare.com/ajax/libs/emojify.js/1.1.0/images/basic' });
    if (this.triggersTotal == 0) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://braincomb.com/cm/triggers.json').then(function (response) {
        if (_this2.isMobile) {
          _this2.sortKey = 'keyword';
          _this2.reverse = false;
          _this2.$store.commit('saveTriggers', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(response.data.triggers, 'dateAdded', 'desc'));
        } else {
          _this2.$store.commit('saveTriggers', __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(response.data.triggers, 'dateAdded', 'desc'));
        }
      }).then(function () {
        _this2.isLoading = false;
      }).catch(function (e) {
        _this2.errors.push(e);
      });
    } else {
      this.isLoading = false;
    }
  },
  mounted: function mounted() {
    document.getElementById("searchTriggers").focus();
  },
  updated: function updated() {}
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'Unknown'
};

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/event-1.3f37ea1e.jpg";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/event-2.70e693c0.jpg";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/event-3.a1ad6962.jpg";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plug-avatars.7dc1386d.jpg";

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(118)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(173),
  /* scopeId */
  "data-v-d7ac51b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(170),
  /* scopeId */
  "data-v-6a82dfde",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(172),
  /* scopeId */
  "data-v-b0135fd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(171),
  /* scopeId */
  "data-v-85e1a8c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(169),
  /* scopeId */
  "data-v-39f06b72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(168),
  /* scopeId */
  "data-v-24e1dcf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(167),
  /* scopeId */
  "data-v-104bcdfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(119)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(174),
  /* scopeId */
  "data-v-dc69dcce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero page-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v("Events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Upcoming and past events.\n          ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero landing-rdj-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]), _vm._v("Upcoming and past events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n        Occasionally we host big events where your favorite big name artists bring you the newest tunes. Don't miss out on hearing the best of music and the opportunity to mingle with producers and DJs.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(120)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(121)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(122)
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero page-triggers"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._m(0), _vm._v(" "), (_vm.triggersTotal != 0) ? _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Instantly search from "), _c('strong', [_vm._v(_vm._s(_vm.triggersTotal))]), _vm._v(" triggers!\n            ")]) : _vm._e()])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right",
    class: {
      'is-loading': _vm.isLoading
    }
  }, [_c('input', {
    staticClass: "input",
    attrs: {
      "id": "searchTriggers",
      "type": "text",
      "placeholder": "Start typing to search a trigger...",
      "value": ""
    },
    on: {
      "input": _vm.debounceSearch,
      "keyup": _vm.keyMonitor
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.itemsFound != _vm.triggersTotal) ? _c('p', {
    staticClass: "control found"
  }, [_vm._v("Found " + _vm._s(_vm.itemsFound) + " triggers.")]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "clickable column-keyword",
    on: {
      "click": function($event) {
        _vm.sortBy('keyword')
      }
    }
  }, [_vm._v("Trigger"), (_vm.sortKey == 'keyword') ? _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.reverse ? 'fa-level-down' : 'fa-level-up'
  })]) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Content")]), _vm._v(" "), (!_vm.isMobile) ? _c('th', {
    staticClass: "clickable column-username",
    on: {
      "click": function($event) {
        _vm.sortBy('creator.username')
      }
    }
  }, [_vm._v("Created By"), (_vm.sortKey == 'creator.username') ? _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.reverse ? 'fa-level-down' : 'fa-level-up'
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('th', {
    staticClass: "clickable column-usecount",
    on: {
      "click": function($event) {
        _vm.sortBy('useCount')
      }
    }
  }, [_vm._v("Times Used"), (_vm.sortKey == 'useCount') ? _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.reverse ? 'fa-level-down' : 'fa-level-up'
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('th', {
    staticClass: "clickable column-created",
    on: {
      "click": function($event) {
        _vm.sortBy('dateAdded')
      }
    }
  }, [_vm._v("Created"), (_vm.sortKey == 'dateAdded') ? _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.reverse ? 'fa-level-down' : 'fa-level-up'
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.limitBy(_vm.filterBy(_vm.triggers, _vm.searchString))), function(trigger) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(trigger.keyword))
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.emojify(_vm.highlight(_vm.linkify(trigger.content))))
      }
    }), _vm._v(" "), (!_vm.isMobile) ? _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(trigger.creator.username))
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('td', [_vm._v(_vm._s(trigger.useCount))]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('td', [_vm._v(_vm._s(_vm.relativeDate(trigger.dateAdded)))]) : _vm._e()])
  }))]), _vm._v(" "), (_vm.itemsFound > _vm.itemsToShow) ? _c('div', [_c('button', {
    staticClass: "button is-primary is-large",
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("Show More")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v("Triggers")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('ul', [_c('li', [_vm._v("We feature beat-focused rather than vocal-focused music. Tracks containing prolonged vocals are subject to evaluation and may be skipped.")]), _vm._v(" "), _c('li', [_vm._v("Check room history before playing. Over-played tracks will be skipped.")]), _vm._v(" "), _c('li', [_vm._v("Search play history with the bot command: "), _c('span', [_vm._v("!plays author - title")])]), _vm._v(" "), _c('li', [_vm._v("Keep all tracks under 8 minutes. 10 minutes if the waitlist is 5 or below.")])])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', {
    staticClass: "user-guidelines"
  }, [_c('h1', {
    staticClass: "title is-4",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" Chat:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("We use the following Plug.dj plugins: "), _c('a', {
    attrs: {
      "href": "https://rcs.radiant.dj/",
      "target": "_blank"
    }
  }, [_vm._v("RCS")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Producers and promoters may self-advertise with SoundCloud or YouTube links. ")]), _vm._v(" "), _c('li', [_vm._v("We love to party; however, we permanent ban trolls, spammers, and those who disrespect the DJs, listeners and staff.")]), _vm._v(" "), _c('li', [_vm._v("Stay active in chat. Send us some funny and interesting images or hit some bot triggers!")]), _vm._v(" "), _c('li', [_vm._v("For unban, unmute or waitlist unblock: Please contact us on Discord or message the room host.")])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-4",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fa fa-music"
  })]), _vm._v(" DJ:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Please listen to a few songs before you DJ, so you get an idea of the room vibe.")]), _vm._v(" "), _c('li', [_vm._v("When in doubt, you can ask a moderator to preview a track by posting a YouTube or SoundCloud link.")]), _vm._v(" "), _c('li', [_vm._v("Staff or the Bot will skip off-genre and off-theme plays.")]), _vm._v(" "), _c('li', [_vm._v("Producers are encouraged to play their own songs, but please do not be obsessive and overplay them.")]), _vm._v(" "), _c('li', [_vm._v("We encourage flow in order to keep the mood of the room steady.")]), _vm._v(" "), _c('li', [_vm._v("For unban, unmute or waitlist unblock: Please contact us on Discord or message any of the room mods.")])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-4",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })]), _vm._v(" How to become a moderator:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("We are always on the look-out for helpful and active users that have the best interest in our community.")]), _vm._v(" "), _c('li', [_vm._v("You should know the genres that we have listed above.")]), _vm._v(" "), _c('li', [_vm._v("You play awesome music consistently for weeks or months.")]), _vm._v(" "), _c('li', [_vm._v("You are a friendly, chatty, mature, and active user.")]), _vm._v(" "), _c('li', [_vm._v("We will approach you, not the other way around!")])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-4",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })]), _vm._v(" Staff guidelines:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Treat others as you would like to be treated. Be patient and be nice in chat.")]), _vm._v(" "), _c('li', [_vm._v("Do not skip any songs based on personal preference. ")]), _vm._v(" "), _c('li', [_vm._v("Inactive (30+ days) staff members will be removed from their position. They will be notified on Discord.")]), _vm._v(" "), _c('li', [_vm._v("Staff members are expected to be present and active in chat while on the wait list.")]), _vm._v(" "), _c('li', [_vm._v("Failure to follow the rules will result in a internal discussion about your removal.")]), _vm._v(" "), _c('li', [_vm._v("The weight of your words is dependent on the validity of the point you are making.")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-rules"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v("Rules")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Community guidelines and room rules. Avoid the banhammer.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-check",
    staticStyle: {
      "color": "#00d1b2"
    }
  })]), _vm._v("We feature "), _c('strong', [_vm._v("electronic based")]), _vm._v(" chillout music:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('ul', [_c('li', [_vm._v("Atmospheric DnB")]), _vm._v(" "), _c('li', [_vm._v("Ambient")]), _vm._v(" "), _c('li', [_vm._v("Acid Jazz")]), _vm._v(" "), _c('li', [_vm._v("Chillhop")]), _vm._v(" "), _c('li', [_vm._v("Chillout Electronica")]), _vm._v(" "), _c('li', [_vm._v("Chillwave")]), _vm._v(" "), _c('li', [_vm._v("Chillstep")]), _vm._v(" "), _c('li', [_vm._v("Chillout Trance")]), _vm._v(" "), _c('li', [_vm._v("Deep House")]), _vm._v(" "), _c('li', [_vm._v("Downtempo")]), _vm._v(" "), _c('li', [_vm._v("Dub")]), _vm._v(" "), _c('li', [_vm._v("Funk")]), _vm._v(" "), _c('li', [_vm._v("Future Garage")]), _vm._v(" "), _c('li', [_vm._v("Indian Chill")]), _vm._v(" "), _c('li', [_vm._v("Instrumental")]), _vm._v(" "), _c('li', [_vm._v("Jazzy Lounge")]), _vm._v(" "), _c('li', [_vm._v("Lofi")]), _vm._v(" "), _c('li', [_vm._v("Lounge")]), _vm._v(" "), _c('li', [_vm._v("Liquid DnB")]), _vm._v(" "), _c('li', [_vm._v("Microhouse")]), _vm._v(" "), _c('li', [_vm._v("Nu-Jazz")]), _vm._v(" "), _c('li', [_vm._v("Melodic Progressive")]), _vm._v(" "), _c('li', [_vm._v("Psychill")]), _vm._v(" "), _c('li', [_vm._v("Psybient")]), _vm._v(" "), _c('li', [_vm._v("Space Music")]), _vm._v(" "), _c('li', [_vm._v("Trip Hop")]), _vm._v(" "), _c('li', [_vm._v("Tribal Fusion")]), _vm._v(" "), _c('li', [_vm._v("Vaporwave")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "red"
    }
  })]), _vm._v("We do "), _c('strong', [_vm._v("not")]), _vm._v(" play:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('ul', [_c('li', [_vm._v("Acoustic")]), _vm._v(" "), _c('li', [_vm._v("Anime")]), _vm._v(" "), _c('li', [_vm._v("Alternative Pop")]), _vm._v(" "), _c('li', [_vm._v("Blues")]), _vm._v(" "), _c('li', [_vm._v("Big Room")]), _vm._v(" "), _c('li', [_vm._v("Brostep")]), _vm._v(" "), _c('li', [_vm._v("Classical")]), _vm._v(" "), _c('li', [_vm._v("Country")]), _vm._v(" "), _c('li', [_vm._v("Drumstep")]), _vm._v(" "), _c('li', [_vm._v("Dubstep")]), _vm._v(" "), _c('li', [_vm._v("Electro House")]), _vm._v(" "), _c('li', [_vm._v("Folk")]), _vm._v(" "), _c('li', [_vm._v("Indie")]), _vm._v(" "), _c('li', [_vm._v("Indie Pop")]), _vm._v(" "), _c('li', [_vm._v("Indie Rock")]), _vm._v(" "), _c('li', [_vm._v("Glitch-Hop")]), _vm._v(" "), _c('li', [_vm._v("Goa Trance")]), _vm._v(" "), _c('li', [_vm._v("Hardstyle")]), _vm._v(" "), _c('li', [_vm._v("Hip-Hop")]), _vm._v(" "), _c('li', [_vm._v("K-Pop")]), _vm._v(" "), _c('li', [_vm._v("J-Pop")]), _vm._v(" "), _c('li', [_vm._v("Jersey Club")]), _vm._v(" "), _c('li', [_vm._v("Mainstream EDM")]), _vm._v(" "), _c('li', [_vm._v("Metal")]), _vm._v(" "), _c('li', [_vm._v("Nightcore")]), _vm._v(" "), _c('li', [_vm._v("Orchestral")]), _vm._v(" "), _c('li', [_vm._v("Piano")]), _vm._v(" "), _c('li', [_vm._v("Pop")]), _vm._v(" "), _c('li', [_vm._v("Pop House")]), _vm._v(" "), _c('li', [_vm._v("Post Rock")]), _vm._v(" "), _c('li', [_vm._v("Punk")]), _vm._v(" "), _c('li', [_vm._v("Rap")]), _vm._v(" "), _c('li', [_vm._v("R&B")]), _vm._v(" "), _c('li', [_vm._v("Rock")]), _vm._v(" "), _c('li', [_vm._v("Reggae")]), _vm._v(" "), _c('li', [_vm._v("Shoegaze")]), _vm._v(" "), _c('li', [_vm._v("Synthpop")]), _vm._v(" "), _c('li', [_vm._v("Tropical House")]), _vm._v(" "), _c('li', [_vm._v("Witch House")]), _vm._v(" "), _c('li', [_vm._v("Video Game Music")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-legal",
    staticStyle: {
      "color": "orange"
    }
  })]), _vm._v("User Guidelines:")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("How to become a Resident DJ?")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("For music producers and YouTube promoters only.")]), _vm._v(" "), _c('li', [_vm._v("You must have music samples on SoundCloud, YouTube, BandCamp, or a personal website.")]), _vm._v(" "), _c('li', [_vm._v("You must be able to demonstrate you play more than just your own music.")]), _vm._v(" "), _c('li', [_vm._v("DJs and Producers: a minimum of 5 tracks/mixes of reasonable quality written within our room's genre requirements.")]), _vm._v(" "), _c('li', [_vm._v("Promoters: 1,000+ followers/subscribers via any medium OR a promising channel with professional graphics, good artist outreach, etc.")])])])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showType),
      expression: "showType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.showType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Show All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "producer"
    }
  }, [_vm._v("Show Producers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "promoter"
    }
  }, [_vm._v("Show Promoters")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.rdjs), function(rdj) {
    return (_vm.showType === 'all' ? rdj.type === 'promoter' || rdj.type === 'producer' : rdj.type === _vm.showType) ? _c('div', {
      staticClass: "column is-2"
    }, [_c('a', {
      attrs: {
        "href": rdj.youtube || rdj.soundcloud,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": rdj.imageUrl,
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title name"
    }, [_vm._v(_vm._s(rdj.name))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle location"
    }, [_vm._v(_vm._s(rdj.location))])])])])])])]) : _vm._e()
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-rdj"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  })]), _vm._v("Resident DJs")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Meet the artists.\n            ")])])])])])])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.authenticated) ? _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "loginForm"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('form', {
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))])]), _vm._v(" "), _vm._m(3)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.authenticated) ? _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('nav', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-heading"
  }, [_vm._v("\n                Add Resident DJ\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "accept": "image/*",
      "type": "file",
      "value": "upload"
    },
    on: {
      "change": function($event) {
        _vm.fileBtn(_vm.file, $event)
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.name),
      expression: "rdj.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.name = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.youtube),
      expression: "rdj.youtube"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.youtube)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.youtube = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.soundcloud),
      expression: "rdj.soundcloud"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.soundcloud)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.soundcloud = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.bandcamp),
      expression: "rdj.bandcamp"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.bandcamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.bandcamp = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.facebook),
      expression: "rdj.facebook"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.facebook = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.twitter),
      expression: "rdj.twitter"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.twitter = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.location),
      expression: "rdj.location"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.rdj.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rdj.location = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('a', {
    staticClass: "panel-block is-active"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rdj.type),
      expression: "rdj.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rdj.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "producer"
    }
  }, [_vm._v("Producer")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "promoter"
    }
  }, [_vm._v("Promoter")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addRdj
    }
  }, [_vm._v("\n                  Upload\n                ")])]), _vm._v(" "), _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('p', {
    staticClass: "help is-success"
  }, [_vm._v(_vm._s(_vm.message))])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-admin"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  })]), _vm._v("Administration Panel")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Sign In")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-medium"
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-user-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-bandcamp"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium is-left"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  })])
}]}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero landing-youtube"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [(_vm.playing) ? _c('div', {
    staticClass: "column",
    staticStyle: {
      "padding-right": "50px"
    }
  }, [_c('div', {
    staticClass: "currentSong"
  }, [_vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange",
      "font-size": "1.75rem"
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.playing.dj))]), _vm._v(" is playing")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    staticStyle: {
      "padding-bottom": "2rem",
      "font-size": "1.5rem"
    }
  }, [_vm._v(_vm._s(_vm.playing.author) + " - " + _vm._s(_vm.playing.title) + " \n                "), _c('a', {
    attrs: {
      "target": "blank",
      "href": _vm.playing.link
    }
  }, [_c('div', {
    staticClass: "tooltip"
  }, [_c('img', {
    attrs: {
      "src": _vm.playing.image
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._l((_vm.played), function(play) {
    return (!_vm.isMobile) ? _c('div', {
      staticClass: "wasPlaying",
      staticStyle: {
        "padding-bottom": "0.85rem"
      }
    }, [_c('h1', {
      staticStyle: {
        "color": "orange",
        "font-size": "1rem"
      }
    }, [_c('strong', {
      staticStyle: {
        "color": "orange"
      }
    }, [_vm._v(_vm._s(play.dj))]), _vm._v(" played\n                  "), _c('div', {
      staticClass: "score",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#90ad2f"
      }
    }, [_vm._m(3, true), _vm._v(_vm._s(play.score.woots))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#aa74ff"
      }
    }, [_vm._m(4, true), _vm._v(_vm._s(play.score.grabs))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#c42e3b"
      }
    }, [_vm._m(5, true), _vm._v(_vm._s(play.score.mehs))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "#bbb"
      }
    }, [_vm._m(6, true), _vm._v(_vm._s(play.score.listeners))])])]), _vm._v(" "), _c('h2', {
      staticClass: "subtitle",
      staticStyle: {
        "font-size": "1rem",
        "border-bottom": "1px solid #bbb",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(play.author) + " - " + _vm._s(play.title) + " "), _c('a', {
      attrs: {
        "target": "blank",
        "href": play.link
      }
    }, [_c('div', {
      staticClass: "tooltip"
    }, [_c('img', {
      attrs: {
        "src": play.image
      }
    })]), _vm._m(7, true)])])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-half",
    staticStyle: {
      "padding-bottom": "5rem"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/SQKG9mqsWgs",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero landing-weekly-events",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_vm._m(9), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              We host a themed party on every Sunday! We pick one or two specific types of music to play. Queue up your favorite tunes and earn "), _c('router-link', {
    attrs: {
      "to": "/bot/games"
    }
  }, [_vm._v("ChillCoins™")]), _vm._v(" when your plays are on theme."), _c('br'), _c('br'), _c('br')], 1)]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _vm._m(11)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "motion-background"
  }, [_c('div', {
    staticClass: "bg-video"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "/video/bg-particles-blue.webm",
      "type": "video/webm"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title text-on-motion"
  }, [_c('span', {
    staticStyle: {
      "color": "#FFF"
    }
  }, [_vm._v("Chillout Music")]), _vm._v(" is a Plug.dj community — a place to play music and videos with friends and others from around the world in a fun, real-time, community-driven environment.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('div', {
    staticClass: "equaliser-container"
  }, [_c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "equaliser-column"
  }, [_c('li', {
    staticClass: "colour-bar"
  })])]), _vm._v("\n                 Currently playing on "), _c('a', {
    attrs: {
      "target": "blank",
      "href": "https://plug.dj/electronic-chillout-music"
    }
  }, [_vm._v("Plug.dj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-star"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yt"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" Our YouTube Channel")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The best of chillout music curated and featured by our very own "), _c('strong', [_vm._v("Molly")]), _vm._v("."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v("Weekly Events")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(123)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero landing-rdj-events"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]), _vm._v("Upcoming and past events")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          Occasionally we host big events where your favorite big name artists bring you the newest tunes. Don't miss out on hearing the best of music and the opportunity to mingle with producers and DJs.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/ComingSoon.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/episode19.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": "/img/events/episode18.jpg"
    }
  })])]), _vm._v(" "), _c('br'), _c('br')])])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-boxed"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.tabUserActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('user')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabModActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('mod')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabGamesActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('games')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.tabLeaderboardActive
    },
    on: {
      "click": function($event) {
        _vm.toggle('leaderboard')
      }
    }
  }, [_vm._m(4)])])]), _vm._v(" "), (_vm.tabUserActive) ? _c('div', [_c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.userCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.tabModActive) ? _c('div', [_c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.modCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.tabGamesActive) ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(7), _vm._v(" "), _c('p', [_vm._v("ChillCoins™ is a unique way to reward our users and provides them with a way of showing their appreciation for spinning super dope tracks. The hope is that this feature will elevate room morale and provide users with incentive to help make the community vibe even more chill than it already is (sub-zero?). Some basic rules are as follows: ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('ul', [_c('li', [_vm._v("Everyone can earn ChillCoins™")]), _vm._v(" "), _c('li', [_vm._v("Anyone can give ChillCoins™")]), _vm._v(" "), _c('li', [_vm._v("Anyone can buy perks with ChillCoins™")])])]), _vm._v(" "), _c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Staff")]), _vm._v(" may award ChillCoins™ to anyone:")]), _vm._v(" "), _c('li', [_vm._v("When awarding non-staff: ChillCoins™ come from the bottomless coffers of the Chillout Music Bank.")]), _vm._v(" "), _c('li', [_vm._v("When awarding other staff members: ChillCoins™ come from the tipper's own wallet.")])])]), _vm._v(" "), _c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Non-Staff Users")]), _vm._v(" may use ChillCoins™ from their wallet to:")]), _vm._v(" "), _c('li', [_vm._v("Exchange coins for perks while on the Wait List to move up a space or even all the way to the front.")]), _vm._v(" "), _c('li', [_vm._v("Tip their homies.")]), _vm._v(" "), _c('li', [_vm._v("Trade Wait List spot with their homies.")])])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.chillcoinCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._m(9), _vm._v(" "), _c('p', [_vm._v("Love is a feature where our users can show appreciation to others in the room. Users can send \"Points\" to other users for any reason they want! After a day, a winner is declared and will benefit from a Wait List Boost and free ChillCoins. We hope that this brings the community closer in a interactive and fun way. Check the "), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggle('leaderboard')
      }
    }
  }, [_vm._v("leaderboard here!")])]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.loveCommands), function(command) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(command.c)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(command.d)
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('ul', [_c('li', [_c('strong', [_vm._v("Rewards:")])]), _vm._v(" "), _c('li', [_vm._v("!love = 0.15 point for source user, 1 for target user")]), _vm._v(" "), _c('li', [_vm._v("!tip = 0.50 for source non-staff user, 1 point for non-staff target user")]), _vm._v(" "), _c('li', [_vm._v("grabs = 0.25 points for each grab, minimum 3 grabs")]), _vm._v(" "), _c('li', [_vm._v("raffle = 1 point for winner")]), _vm._v(" "), _c('li', [_vm._v("trivia = 1 point for winner")]), _vm._v(" "), _c('li', [_vm._v("One prize (every 24 hours): Wait List Boost, which pushes the user 2 thirds of the way up the waitlist and 3 ChillCoins.")]), _vm._v(" "), _c('li', [_vm._v("* Users can accumulate boost and use it at their time of choosing.")])])])], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.tabLeaderboardActive) ? _c('div', [_c('div', {
    staticClass: "box"
  }, [_vm._m(13), _vm._v(" "), _c('p', [_vm._v("Leaderboard has been reset "), _c('strong', [_vm._v(_vm._s(_vm.leaderboard.started))]), _vm._v(" and will end "), _c('strong', [_vm._v(_vm._s(_vm.leaderboard.ends))]), _vm._v(". Watch this space! Winners can type "), _c('strong', [_vm._v("!use boost")]), _vm._v(" in our Plug.dj room to use the free boost and get free ChillCoins.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table is-striped"
  }, [_vm._m(14), _vm._v(" "), _c('tbody', _vm._l((_vm.leaderboard.participants), function(participant) {
    return _c('tr', [_c('td', {
      domProps: {
        "innerHTML": _vm._s(participant.username)
      }
    }), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(participant.points_received)
      }
    }), _vm._v(" "), _c('td', _vm._l((participant.awards_received), function(award) {
      return _c('span', [_vm._v(_vm._s(award.username) + " (" + _vm._s(award.points_sent) + ") ")])
    }))])
  }))])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero page-bot"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  })]), _vm._v(" Bot")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              ChilloutRoomba - the artificial intelligence serving cat pictures and banhammers.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("User Commands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Mod Commands")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Games")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("Leaderboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd"
  })]), _vm._v("ChillCoin™")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" Love")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Command")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "#BBB"
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc"
  })]), _vm._v("Raffle")]), _vm._v(" "), _c('p', [_vm._v("Raffle, which occurs every 30 minutes, provides a significant Wait List Boost to the winners. If you are already in position #1, you will need to lock your spot by typing "), _c('strong', [_vm._v("!join")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/raffle_01.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  })]), _vm._v("Trivia")]), _vm._v(" "), _c('p', [_vm._v("Trivia is a fun game to test your knowledge on various topics, provides a small Wait List Boost. Held every 3 hours. Each correct response will need to be preceded by "), _c('strong', [_vm._v("!a")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/img/trivia_01.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title is-3",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large",
    staticStyle: {
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" Leaderboard")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "column-keyword"
  }, [_vm._v("Username")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Points")]), _vm._v(" "), _c('th', {
    staticClass: "column-content"
  }, [_vm._v("Lovers")])])])
}]}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "nav-with-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item is-brand",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/cm-logo.svg",
      "alt": "Chillout Music"
    }
  }), _vm._v("  Chillout Music\n          ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.isHamburgerActive
    },
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/rdj",
      "exact": ""
    }
  }, [_vm._v("Residents DJs")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/rules",
      "exact": ""
    }
  }, [_vm._v("Rules")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/bot"
    }
  }, [_vm._v("Bot")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/triggers",
      "exact": ""
    }
  }, [_vm._v("Triggers")]), _vm._v(" "), _vm._m(0)], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "https://plug.dj/electronic-chillout-music",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Join us on Plug.dj")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-3"
  }, [_c('p', [_vm._v("Chillout Music © 2014-2019")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "position": "relative",
      "left": "-13px"
    }
  }, [_c('a', {
    staticClass: "facebook",
    attrs: {
      "href": "https://www.facebook.com/chilloutmusic.fm",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "https://www.twitter.com/chilloutmusica",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "reddit",
    attrs: {
      "href": "https://www.reddit.com/r/ChilloutMusic",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-reddit"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "youtube",
    attrs: {
      "href": "https://www.youtube.com/channel/UCfXtga41r3-IiV7Nlm_VvKw?sub_confirmation=1",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-youtube"
  })])]), _vm._v("\n               "), _c('a', {
    staticClass: "soundcloud",
    attrs: {
      "href": "https://soundcloud.com/chilloutmusica",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-soundcloud"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('p', [_vm._v("Join us on Discord:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://discord.gg/44Mkdqh",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/img/social-join-discord-2.png"
    }
  })])])])])])])
}]}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero page-unknown"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container page-header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('span', {
    staticClass: "icon is-large"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" Page not found")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Sorry but the page you requested doesn't exist.\n            ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('video', {
    attrs: {
      "autoplay": "",
      "loop": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "https://i.imgur.com/a0voxPE.mp4",
      "type": "video/mp4"
    }
  })])])])])])
}]}

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(49);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(51);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[181]);


// WEBPACK FOOTER //
// client.5acfc94e.js